module.exports = __webpack_public_path__ + "img/fauna.940d56d1.png";